
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GetterSetter } from 'app/shared/common/helper/project';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ToastrService } from 'ngx-toastr';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DatePipe } from '@angular/common';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { CommonValidation } from 'app/shared/common/common-validation';
import axios from 'axios';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';

@Component({
  selector: 'app-add-ons',
  templateUrl: './add-ons.component.html',
  styleUrls: ['./add-ons.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddOnsComponent implements OnInit {

  isEdit: boolean;
  objectId = '';
  ProjectId = '';
  empRole = '';
  projectInformationForm: FormGroup;
  projectInformation: any;
  projectValue: any;
  startdate: any;
  enddate: any;
  show: boolean = true;
  startDate: any;
  endday: any;
  clientList = [];
  platformList = [];
  projectLists = [];
  projectStatusList = [];
  resourcesLists = [];
  gitupLists = [];
  statusLists = [];
  fileToUpload: File = null;
  resourceDetailDate: string = '';
  resourceDropdown = [];
  isResourceChanged = false;
  totalCount: number = 0;
  totalHours: number = 0;
  mode: any;
  projectName: string;
  currentResourceDetail: any;
  index: number;
  projectType: string;
  nonBillableCount = [];
  parentProjectId: any;
  currentUser = this.parseService.instance.User.current();
  projectActivities = [];
  today = new Date();
  // Comments
  commentData = [];
  commentsForm: FormGroup;
  commentsFormErrors: { comments: {}; };
  firstname: String;
  lastname: String;
  newDate = Date.now();
  noData = false;
  projectStatus: any;

  // released resource
  userIdArr = [];
  totalReleasedResources: number;
  releasedResources = [];
  @Input() projectId: any;
  cols: any[];
  reason = false;

  // assigned resources
  totalAssignedResources: number;
  rowData = [];
  filterArray = [];
  selectedResource = [];
  totalResources: number;
  loadEventData: LazyLoadEvent;
  rowDatas = [];
  popupForm: FormGroup;
  userId: any;
  popupValue: any;
  selectedRows = [];
  resourceForm: FormGroup;
  cols1: any[];
  projectTypeOptions: SelectItem[];
  rollOptions: SelectItem[];
  deptOptions: SelectItem[];
  locationDD = [];
  locationOptions: SelectItem[];
  deptDD = [];
  roleDD = [];
  rollOptions1: any[];
  assignedResources = [];
  reAssignResourcePopupForm: FormGroup;
  activities = [];
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];
  userCompareId = [];
  userIds = [];
  projetcDetails: any;
  roleOptions: any[];
  roleOptionsDD = [];
  resourceDetails = [];
  roles: any[];
  @Output() isEditValue = new EventEmitter<boolean>();
  projectStartDate: string = '';
  actualCompletionDate: string = '';
  extendedCompletionDate: string = '';
  displayedColumn: string[] = ['role', 'count', 'hours', 'delete'];
  displayedColumns: string[] = ['role', 'count', 'hours',];
  dataSources = new MatTableDataSource<resourceTableModel>([]);
  reassignSave = false;
  srs = [];
  plan = [];
  endDate: any;
  addons: addon[] = [
    { value: 'Addon', viewValue: 'Addon' },
    { value: 'Support', viewValue: 'Support' },
    { value: 'Task', viewValue: 'Task' },

  ];
  noOfResource: any[] = [
    { value: 0, viewValue: '0' },
    { value: 1, viewValue: '1' },
    { value: 2, viewValue: '2' },
    { value: 3, viewValue: '3' },
    { value: 4, viewValue: '4' },
    { value: 5, viewValue: '5' },
    { value: 6, viewValue: '6' },
    { value: 7, viewValue: '7' },
    { value: 8, viewValue: '8' },
    { value: 9, viewValue: '9' },
    { value: 10, viewValue: '10' }
  ];

  @ViewChild('projectEditPopup', { static: false }) projectEditPopup: TemplateRef<any>;
  @ViewChild('projectDialog', { static: false }) projectDialog: TemplateRef<any>;
  @ViewChild('projectaddonDialog', { static: false }) projectaddonDialog: TemplateRef<any>;
  @ViewChild('reAssignResourcePopup', { static: false }) reAssignResourcePopup: TemplateRef<any>;
  @ViewChild('assignedResources', { static: false }) private assignee: any;
  @ViewChild('released', { static: false }) private release: any;
  @ViewChild("scrumboard", { static: false }) scrumboard: TemplateRef<any>;

  name: string;
  resource: any[];
  mail: string;
  desig: any[];
  roleType: any[];
  colsRelease: { header: string; field: string; }[];
  supportBillableCount: any[] = [];
  currentProjectDetails: any;
  currentResourcetDetails: any;
  username: any;
  currentValues: any;
  oldValueResource: any;
  newValues: any;
  activity: any;
  addOnsValue: any;
  addOnsActivities = [];
  reAssignedResource: string;
  typeOfProject: string;
  currentStatus: any;
  previousReason: any;
  projecttypeInfo: any;
  projectReason: string;
  statusdisable: boolean = false;
  apiUrl: any;
  scrumBoard = false;
  resourcesTypeLists = [];
  currentDetails: any;
  currentUsername: any;
  oldReassignValue: any;

  constructor(
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private projectInterface: GetterSetter,
    private dateConvertor: DateConvertor,
    private toastr: ToastrService,
    private toastMessage: ToastBaseModel,
    private profileDropDown: GetOperations,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    public dialog: MatDialog,
    private sessionHandler: SessionHandler,
    private commonValidation: CommonValidation,
    private hardCodedValues: HardCodedValues,
    private _scrumboardService: ScrumboardService,
    private activityCenterService: ActivityCenterService,
    private getReportingToService: GetReportingToService
  ) {
    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Name', field: 'username' },
      { header: 'Start Date', field: 'startDate' },
      { header: 'End Date', field: 'endDate' },
      { header: 'Resource Type', field: 'resourceType' },
      { header: 'Status', field: 'status' },
      { header: 'Email', field: 'email' },
      { header: 'Role', field: 'role' },
      { header: 'Designation', field: 'designation' },
      { header: 'Action', field: 'action' },

    ];

    this.colsRelease = [
      { header: 'S.No', field: 'position' },
      { header: 'Name', field: 'username' },
      { header: 'Email', field: 'email' },
      { header: 'Start Date', field: 'startDate' },
      { header: 'End Date', field: 'endDate' },
      { header: 'Resource Type', field: 'resourceType' },
      { header: 'Designation', field: 'designation' },
      { header: 'Status', field: 'status' }

    ];

    this.projectTypeOptions = [];

    this.cols1 = [
      { header: 'Name', field: 'userName' },
      { header: 'Email', field: 'officialEmail' },
      { header: 'Department', field: 'department' },
      { header: 'Role', field: 'role' },
      { header: 'Start Date', field: 'startDate' },
      { header: 'Resource Type', field: 'resourceType' }
    ];

    this.resourcesTypeLists = [
      { value: 'Dedicated-Billable', viewValue: 'Dedicated-Billable' },
      { value: 'Dedicated Non-Billable', viewValue: 'Dedicated Non-Billable' },
      { label: 'Fixed-Billable', value: 'Fixed-Billable' },
      { label: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
      { value: 'Dedicated Proxy', viewValue: 'Dedicated Proxy' },
      { value: 'Bench', viewValue: 'Bench' },
      { value: 'Trainee', viewValue: 'Trainee' },
      { label: 'Support-Billable', value: 'Support-Billable' },
      { label: 'Support Non-Billable', value: 'Support Non-Billable' },
      { value: 'Training', viewValue: 'Training' }
    ];

    this.reAssignResourcePopupForm = this.formBuilder.group({
      name: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      resourceType: ['', Validators.required],
      userId: [, Validators.required],
      projectId: ['', Validators.required],
      isActive: ['', Validators.required],
      status: ['', Validators.required],
      role: ['', Validators.required],
    });

    this.projectInformationForm = this.formBuilder.group({
      clientName: ['', Validators.required],
      projectName: ['', Validators.required],
      projectType: ['', Validators.required],
      currentStatus: ['', Validators.required],
      projectStartDate: ['', Validators.required],
      addOnType: ['', Validators.required],
      actualCompletionDate: [''],
      extendedCompletionDate: [''],
      reason: [''],
      projectPlatform: ['', Validators.required],
      projectDescription: [''],
      schedulerStatus: [''],
      srs: [],
      plan: []
    });
    this.commentsForm = this.formBuilder.group({
      comments: [''],
    });
    this.commentsFormErrors = {
      comments: {}
    };
  }

  async ngOnInit() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(settings => {
      this.apiUrl = settings[0].get('apiUrl');
    });

    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.isEdit = false;
    // Project Create
    this.route.queryParams.subscribe(params => {
      this.ProjectId = params['ProjectId'];
      this.mode = params['mode'];

      if (this.ProjectId != '' && this.ProjectId != undefined) {
        this.isEdit = true;
      }
    });

    // Projects edit
    this.isEdit = false;
    this.route.params.subscribe(params => {
      this.objectId = params['events'];
      this.parentProjectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getProjectInformation();
        this.getLeadersProjectId();
      }
    });

    this.getResourceType();
    this.getClient();
    if (this.mode != 'add') {
      this.getReleasedResources();
      this.getProject();
      this.getActivities();
    }

    this.getComments();

    if (this.mode == 'add') {
      this.getAddonInfo();
    }
    this.popupForm = this.formBuilder.group({
      username: ['', Validators.required],
      startdate1: ['', Validators.required],
      enddate1: ['', Validators.required],
      popupStatus: ['', Validators.required],
      popupRole: ['', Validators.required],
      popupResourcesType: ['', Validators.required]
    });

    this.resourceForm = this.formBuilder.group({
      startdate: ['', Validators.required],
      resourcetype: ['', Validators.required],
    });
    this.getLocation();
    this.getDepartment();
    this.getRollOption();
    this.getAssignedResources();
    this.getReportingTo();
  }

  checkScrumboard() {
    this.queryInterface.executeQuery(this.parseService, 'Sprint', [{ condition: 'include', field: 'project' },
    { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.currentProjectDetails.id } }]).then(res => {
      if (res.length > 0) {
        this.scrumBoard = false;
      }
      else {
        this.scrumBoard = true;
      }
    });
  }

  /*
 ** ==========================================================
 ** Create scrumboard
 ** ==========================================================
 */
  createScrumboard() {
    this.queryInterface.executeQuery(this.parseService, 'Sprint', [{ condition: 'include', field: 'project' },
    { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.currentProjectDetails.id } }]).then(res => {
      if (res.length > 0) {
        this.toastr.warning('Backlogs already exist for this project')
      }
      else {
        this.dialog.closeAll();
        this._scrumboardService.createScrumBoard(this.currentProjectDetails);
        this.scrumBoard = false;
        this.router.navigate(['/scrumboard/board/analytics/' + this.projectId + '/' + this.projectName]);
      }
    });
  }

  scrumboardConfirmation() {
    this.dialog.open(this.scrumboard, {
      width: "300px"
    });
  }

  closs() {
    this.dialog.closeAll();
  }

  getActivities() {
    if (this.objectId != undefined) {
      let condition = [];
      let type = '';
      if (this.empRole == 'Admin') {
        condition = [
          { condition: 'equalTo', field: 'objectId', value: this.objectId },
          { condition: 'include', value: 'client' }
        ];
        type = 'Project';
      } else {
        condition = [
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } },
        ];
        type = 'ProjectMembers';
      }
      this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
        const result = results[0];
        if (this.empRole == 'Admin') {
          this.addOnsValue = this.projectInterface.getProject(result);
          this.addOnsActivities = this.addOnsValue.activities;
          let activity = this.addOnsActivities
          this.activities = activity.slice(0, 50);
          this.projectId = result.id;
        } else {
          this.addOnsValue = this.projectInterface.getProject(result.get('project'));
          this.addOnsActivities = this.addOnsValue.activities;
          let activity = this.addOnsActivities
          this.activities = activity.slice(0, 50);
          this.projectId = result.get('project').id;
        }
      });
    }
  }

  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();

    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(dropdownresults),
      projectPlatformsobj = this.platformList,
      currentStatusObj = this.projectStatusList,
      gitStatusObj = this.gitupLists,
      gitupLists = profileDropDownValue.gitStatus,
      projectStatusList = profileDropDownValue.currentStatus,
      platformList = profileDropDownValue.projectPlatforms;

    this.statusLists = profileDropDownValue.popupStatus;
    this.projectLists = profileDropDownValue.projectType;

    for (var i = 0; i < platformList.length; i++) {
      projectPlatformsobj.push(platformList[i]);
    }
    for (var i = 0; i < projectStatusList.length; i++) {
      currentStatusObj.push(projectStatusList[i]);
    }
    for (var i = 0; i < gitupLists.length; i++) {
      gitStatusObj.push(gitupLists[i]);
    }

    this.resourcesLists = [];
    this.projectTypeOptions = [];

    if (this.projectInformationForm.value.addOnType == 'Addon') {

      if (this.projectInformationForm.value.projectType == 'Fixed') {
        this.resourcesLists.push({ value: 'Fixed-Billable', viewValue: 'Fixed-Billable' },
          { value: 'Fixed Non-Billable', viewValue: 'Fixed Non-Billable' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions.push({ label: 'Fixed-Billable', value: 'Fixed-Billable' },
          { label: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' });
      }
      if (this.projectInformationForm.value.projectType == 'Dedicated') {
        this.resourcesLists.push({ value: 'Dedicated-Billable', viewValue: 'Dedicated-Billable' },
          { value: 'Dedicated Non-Billable', viewValue: 'Dedicated Non-Billable' },
          { value: 'Dedicated Proxy', viewValue: 'Dedicated Proxy' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions = [
          { label: 'Dedicated Non-Billable', value: 'Dedicated Non-Billable' },
          { label: 'Dedicated-Billable', value: 'Dedicated-Billable' },
          { label: 'Dedicated Proxy', value: 'Dedicated Proxy' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' }];

      }
    }
    else if (this.projectInformationForm.value.addOnType == 'Support') {
      this.resourcesLists.push({ value: 'Support-Billable', viewValue: 'Support-Billable' },
        { value: 'Support Non-Billable', viewValue: 'Support Non-Billable' });

      this.projectTypeOptions = [
        { label: 'Support-Billable', value: 'Support-Billable' },
        { label: 'Support Non-Billable', value: 'Support Non-Billable' }];
    }
    else if (this.projectInformationForm.value.addOnType == 'Task') {
      this.resourcesLists.push({ value: 'Training', viewValue: 'Training' });
      this.projectTypeOptions.push({ label: 'Training', value: 'Training' });
    }
  }

  async getClient() {
    var clientName = [];
    await this.queryInterface.executeQuery(this.parseService, 'Client', [{ field: 'name', condition: 'descending' },
    { condition: 'limit', value: 10000 }]).then(results => {
      let jsonText = JSON.stringify(results);
      let clients = JSON.parse(jsonText);
      for (let client of clients) {
        clientName = client.companyInfo.firstName;
        this.clientList.push({
          id: client.objectId,
          name: clientName.concat(' ' + client.companyInfo.lastName)
        });
      }
    });
  }

  fileUpload(event, type) {
    var formData = new FormData();
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file.type == 'application/pdf' || file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/msword' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type == 'application/vnd.ms-excel') {
        formData.append('files', file);
        // this.deleteprofileimage();
        var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
        axios.post(this.apiUrl.mediaPath, formData, {
          headers: {
            // 'authorization': 'Bearer r:275fc76ef2168814a16b37a759eb538c',
            'authorization': 'Bearer ' + session,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(responseData => {
          var response = responseData;

          let name = response.data.url.split('/');
          if (type == 'srs') {
            this.srs.push({ id: response.data._id, name: name[4], url: response.data.url });
          } else if (type == 'plan') {
            this.plan.push({ id: response.data._id, name: name[4], url: response.data.url });
          }
          this.toastr.success('File Uploaded Successfully');

          let activityNew = [];
          let currentUsername = this.firstname + ' ' + this.lastname;
          // tslint:disable-next-line: max-line-length
          let message = ' Added a file ' + response.data.url;
          activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            this.projectActivities.unshift(element);
          });
          let id = '';
          id = this.empRole == 'Admin' ? this.objectId : this.projectId;
          this.activityCenterService.createActivity(activityNew, this.hardCodedValues.addons, id);

          this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
            var results = result[0];
            results.set('activities', this.projectActivities);
            results.save().then(res => {
            });
          });


        }).catch(err => {
          if (err.message == 'Network Error') {
            this.toastr.warning('Something went wrong');
          } else if (err.response.data.message == 'Please upload the image less than 500kb') {
            this.toastr.warning('Please upload the file less than 500kb');
          }
        });
      } else {
        this.toastr.warning('Document and Pdf files only accepted');
      }
    }
  }

  deleteFile(id, type) {
    const fileId = id;
    // if (this.projectInformationForm.value.srsId != undefined) {
    var session = this.storageConfiguration.sessionGetItem(this.storageConfiguration.sessiontoken);
    axios.delete(this.apiUrl.mediaPath + id, {
      headers: {
        "authorization": "Bearer " + session,
        // 'authorization': 'Bearer r:ce454e31d065189714ea31515f6372cf',
        'Content-Type': 'application/json'
      }
    }).then(aresf => {
      let fileIndex;
      if (type == 'srs') {
        fileIndex = this.srs.findIndex(x => x.id == fileId);
        this.srs.splice(fileIndex, 1);
      } else if (type == 'plan') {
        fileIndex = this.plan.findIndex(x => x.id == fileId);
        this.plan.splice(fileIndex, 1);
      }

      let proId = this.empRole == 'Admin' ? this.objectId : this.projectId;
      if (proId != undefined) {
        this.updateProjectInformation();
      }

      let activityNew = [];
      // tslint:disable-next-line: max-line-length
      let message = ' Removed a file ' + fileId;
      activityNew.push(this.setActivityModel(message));
      activityNew.forEach(element => {
        this.projectActivities.unshift(element);
      });
      let id = '';
      id = this.empRole == 'Admin' ? this.objectId : this.projectId;

      this.activityCenterService.createActivity(activityNew, this.hardCodedValues.addons, this.objectId);

      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
        var results = result[0];
        results.set('activities', this.projectActivities);
        results.save().then(res => {
        });
      });
    });
  }

  changeCount(val, rowData) {
    let res = [];
    if (rowData != '') {
      res = this.assignedResources.filter(x => x.role == rowData.role);
    }
    if (res.length > val) {
      let count = res.length - val;
      this.toastr.warning('Please release ( ' + count + ' ' + rowData.role + '  Resource ) before reducing count');
      this.getProjectInformation();

    } else {
      this.isResourceChanged = true;
      this.totalCount = 0;
      this.dataSources.data.forEach(element => {
        this.totalCount += element.count;
      });
    }
  }

  changeHourCount(event) {
    this.isResourceChanged = true;
    this.totalHours = 0;
    this.dataSources.data.forEach(element => {
      this.totalHours += element.hours;
    });
  }

  getCount() {
    let total = 0;
    this.dataSources.data.forEach(element => {
      total = element.count + total;
    });
    return total;
  }

  getHoursCount() {
    let total = 0;
    this.dataSources.data.forEach(element => {
      total += element.hours;
    });
    return total;
  }

  getAddonInfo() {
    this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.ProjectId },
    { condition: 'include', value: 'client' }]).then(results => {
      const result = results[0];
      const projectValue = result.get('projectInfo');
      const client = result.get('client');
      this.projectInformationForm.patchValue({
        clientName: client.id,
        projectName: projectValue.projectName,
        projectType: projectValue.projectType,
        projectPlatform: projectValue.projectPlatform,
      });
      this.getDropDowns();
      this.hide(this.projectInformationForm.value.projectType);
    });
  }

  getProjectInformation() {
    if (this.empRole != 'Employee') {
      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
      { condition: 'include', value: 'client' }]).then(async result => {
        var results = result[0];
        let projectResults = JSON.stringify(results);
        let proModel = JSON.parse(projectResults);
        this.projectValue = this.projectInterface.getProject(results);

        this.currentStatus = this.projectValue.projectInfo.currentStatus;
        this.projectId = this.projectValue.id;
        this.projectName = this.projectValue.projectInfo.projectName;

        this.currentProjectDetails = this.projectValue;
        this.checkScrumboard();
        this.projectActivities = this.projectValue.activities;
        this.currentResourcetDetails = JSON.parse(JSON.stringify(this.projectValue.resourceDetails.details));

        this.dataSources.data = this.projectValue.resourceDetails.details;
        this.currentResourceDetail = JSON.parse(JSON.stringify(this.projectValue.resourceDetails));

        this.getResourceType();
        this.resourceDetailDate = this.projectValue.resourceDetails.resourceDetailDate;
        this.totalCount = await this.getCount();
        this.totalHours = this.getHoursCount();
        this.startdate = this.projectValue.projectInfo.projectStartDate;
        this.projectValue.projectInfo.addOnType == 'Task' ? this.show = true : this.show = false;

        this.projecttypeInfo = JSON.parse(JSON.stringify(this.projectValue.projectInfo.projectType));

        if (this.projectValue.projectInfo.currentStatus == 'Completed') {
          this.statusdisable = true;
        }

        if (proModel.projectInfo.projectType == 'Dedicated') {
          this.show = false;

          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            projectType: this.projectValue.projectInfo.projectType,
            addOnType: this.projectValue.projectInfo.addOnType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
        } else if (proModel.projectInfo.projectType == 'Fixed') {
          this.show = true;
          this.actualCompletionDate = this.projectValue.projectInfo.actualCompletionDate;
          this.extendedCompletionDate = this.projectValue.projectInfo.extendedCompletionDate;
          this.projectStartDate = this.projectValue.projectInfo.projectStartDate;
          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            projectType: this.projectValue.projectInfo.projectType,
            addOnType: this.projectValue.projectInfo.addOnType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
        }
        else if (proModel.projectInfo.addOnType == 'Support' || proModel.projectInfo.addOnType == 'Addon' || proModel.projectInfo.addOnType == 'Task') {
          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            projectType: this.projectValue.projectInfo.projectType,
            addOnType: this.projectValue.projectInfo.addOnType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
        }
        this.currentDetails = JSON.parse(JSON.stringify(this.projectInformationForm.value));

        this.srs = this.projectValue.projectInfo.srs == undefined ? [] : this.projectValue.projectInfo.srs;
        this.plan = this.projectValue.projectInfo.plan == undefined ? [] : this.projectValue.projectInfo.plan;
        this.getAssignedResources();
        this.getDropDowns();
        // this.hide(this.projectValue.projectInfo.projectType);

        this.projectReason = this.projectValue.projectInfo.reason;
        if (this.projectValue.projectInfo.reason !== '' && this.projectValue.projectInfo.reason !== undefined) {
          this.status(this.projectReason);
        }
      });
    } else if (this.empRole == 'Employee') {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [{ condition: 'include', value: 'project' }, { condition: 'include', value: 'project.client' },
      { condition: 'include', value: 'user' },
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]).then(results => {
        var result = results[0];
        let jsonText = JSON.stringify(result);
        let projectValue = JSON.parse(jsonText);
        this.dataSources.data = projectValue.project.resourceDetails.details;
        this.getResourceType();
        this.projectValue = this.projectInterface.getProject(result.get('project'));

        this.currentStatus = this.projectValue.projectInfo.currentStatus;
        this.projectId = this.projectValue.id;
        this.projectName = this.projectValue.projectInfo.projectName;

        this.currentProjectDetails = this.projectValue;
        this.projectActivities = this.projectValue.activities;
        this.currentResourcetDetails = JSON.parse(JSON.stringify(this.projectValue.resourceDetails.details));

        this.projectValue.projectInfo.addOnType == 'Task' ? this.show = true : this.show = false;

        if (this.projectValue.projectInfo.currentStatus == 'Completed') {
          this.statusdisable = true;
        }

        this.totalCount = this.getCount();
        this.totalHours = this.getHoursCount();
        this.startdate = this.projectValue.projectInfo.projectStartDate;
        this.enddate = this.projectValue.projectInfo.projectType;
        if (this.projectValue.projectInfo.projectType == 'Dedicated') {
          this.show = false;
          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            addOnType: this.projectValue.projectInfo.addOnType,
            projectType: this.projectValue.projectInfo.projectType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
          this.projectId = this.projectValue.objectId;
        } else if (this.projectValue.projectInfo.projectType == 'Fixed') {
          this.show = true;
          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            addOnType: this.projectValue.projectInfo.addOnType,
            projectType: this.projectValue.projectInfo.projectType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
          this.projectId = this.projectValue.objectId;
        }
        else if (this.projectValue.projectInfo.addOnType == 'Support' || this.projectValue.projectInfo.addOnType == 'Addon' || this.projectValue.projectInfo.addOnType == 'Task') {
          this.projectInformationForm.patchValue({
            clientName: this.projectValue.client,
            projectDescription: this.projectValue.projectInfo.projectDescription,
            projectName: this.projectValue.projectInfo.projectName,
            addOnType: this.projectValue.projectInfo.addOnType,
            projectType: this.projectValue.projectInfo.projectType,
            currentStatus: this.projectValue.projectInfo.currentStatus,
            projectStartDate: this.projectValue.projectInfo.projectStartDate,
            projectPlatform: this.projectValue.projectInfo.projectPlatform,
            actualCompletionDate: this.projectValue.projectInfo.actualCompletionDate,
            extendedCompletionDate: this.projectValue.projectInfo.extendedCompletionDate,
            reason: this.projectValue.projectInfo.reason == undefined ? '' : this.projectValue.projectInfo.reason,

            schedulerStatus: this.projectValue.schedulerStatus ? this.projectValue.schedulerStatus : ''
          });
          this.projectId = this.projectValue.objectId;

        }
        this.getAssignedResources();
        this.getDropDowns();
        this.srs = this.projectValue.projectInfo.srs == undefined ? [] : this.projectValue.projectInfo.srs;
        this.plan = this.projectValue.projectInfo.plan == undefined ? [] : this.projectValue.projectInfo.plan;

        this.projectReason = this.projectValue.projectInfo.reason;
        if (this.projectValue.projectInfo.reason !== '' && this.projectValue.projectInfo.reason !== undefined) {
          this.status(this.projectReason);
        }

      });
    }
  }

  addOnType(event) {
    if (event.value == 'Support' || event.value == 'Task') {

      this.projectInformationForm.patchValue({
        projectType: ''
      });
    }
  }

  public hide(event) {
    if (event == 'Dedicated' || event == 'Support') {
      this.show = false;
    } else if (event == 'Fixed' || event == 'Task') {
      this.show = true;
    }
  }

  status(event) {
    if (this.projectReason !== '' && this.isEdit) {
      this.reason = true;
      this.projectInformationForm.controls['reason'].setValidators([Validators.required]);
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
    }
  }

  statusChange(event) {
    if (event == 'Archived' && (this.nonBillableCount.length > 0 || (this.assignedResources.length - this.nonBillableCount.length) > 0)) {
      this.toastr.warning('Please release the assigned resource(s) before Archive the project.');
      this.projectInformationForm.patchValue({
        currentStatus: this.projectValue.projectInfo.currentStatus
      });
    }

    if (this.projectStatus !== event && this.isEdit) {
      this.reason = true;
      this.projectInformationForm.controls['reason'].setValidators([Validators.required]);
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
      this.projectInformationForm.patchValue({
        reason: '',
      });
    } else {
      this.reason = false;
      this.projectInformationForm.controls['reason'].clearValidators();
      this.projectInformationForm.controls['reason'].updateValueAndValidity();
      this.projectInformationForm.patchValue({
        reason: this.previousReason,
      });
    }
  }

  nameChange(pname) {
    pname = this.nameCapitalChange(pname);
    this.projectInformationForm.patchValue({
      projectName: pname
    });
  }
  nameCapitalChange(event) {
    event = event.toLowerCase();
    return event.replace(/\b\w/g, l => l.toUpperCase());
  }
  changeDate(event) {
    var endDate = this.dateConvertor.momentChange(event.value);
    this.noOfDays();
  }

  noOfDays() {
    var projectStartDate = new Date(this.projectInformationForm.value.projectStartDate);
    var projectEndDate = new Date(this.projectInformationForm.value.actualCompletionDate);
    var oneDay = 24 * 60 * 60 * 1000;
    var dateDifferences = Math.round(Math.abs((projectStartDate.getTime() - projectEndDate.getTime()) / (oneDay)));
    return dateDifferences;
  }

  async updateProjectInformation() {
    let allowSave = true;
    const errorArray = [];

    const controls = this.projectInformationForm.controls;
    // tslint:disable-next-line: forin
    if (this.projectInformationForm.value.addOnType == 'Support' || this.projectInformationForm.value.addOnType == 'Task') {
      for (const value in controls) {
        if (controls[value].invalid) {
          if (value != 'projectType') {
            allowSave = false;
            errorArray.push(value);
          }
        }
      }
    } else {
      for (const value in controls) {
        if (controls[value].invalid) {
          allowSave = false;
          errorArray.push(value);
        }
      }
    }

    if (this.dataSources.data.length <= 0) {
      allowSave = false;
      errorArray.push('Resources');
    }

    let roleCheck = this.dataSources.data.filter(a => a.role == '');
    let resourceCheck = this.dataSources.data.filter(a => a.count == 0);
    let hourCheck = this.dataSources.data.filter(a => a.hours == 0);
    if (roleCheck.length > 0) {
      allowSave = false;
      errorArray.push('Role');
    }
    if (resourceCheck.length > 0) {
      allowSave = false;
      errorArray.push('No Of Resources');
    }
    if (hourCheck.length > 0 && (this.projectInformationForm.value.projectType == 'Fixed' || this.projectInformationForm.value.addOnType == 'Task')) {
      allowSave = false;
      errorArray.push('Hours');
    }
    let projectresourceDetails = this.currentResourceDetail;
    let currentResourceCount = 0;
    let oldResourceCount = 0;
    this.dataSources.data.forEach(element => {
      currentResourceCount += element.count;
    });

    if (projectresourceDetails) {
      projectresourceDetails.details.forEach(element => {
        oldResourceCount += element.count;
      });
    }

    const profileValues = this.projectInformationForm.value;
    profileValues.srs = this.srs;
    profileValues.plan = this.plan;

    if (allowSave) {
      if (currentResourceCount != oldResourceCount) {
        this.resourceDetailDate = new Date(new Date().setHours(0, 0, 0, 0)).toISOString();
      }

      if (this.empRole != 'Employee') {
        if (this.show == false) {
          let profileValues = this.projectInformationForm.value;
          let resourceDetails = {
            details: this.dataSources.data,
            resourceDetailDate: this.dateConvertor.addGMTOffset(new Date(this.resourceDetailDate)).toISOString()
          };

          let activities = await this.getActivity(this.currentProjectDetails.projectInfo, profileValues);
          activities.forEach(element => {
            this.projectActivities.unshift(element);
          });

          const projectId = this.objectId;

          let activitiesCenter = await this.activityCenterService.getActivity(this.currentDetails, profileValues, this.hardCodedValues.addons);
          this.activityCenterService.createActivity(activitiesCenter, this.hardCodedValues.addons, projectId);

          // this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, projectId);

          let resourceDetailsActivity = await this.getActivityResource(this.currentResourcetDetails, resourceDetails.details);
          resourceDetailsActivity.forEach(element => {
            this.projectActivities.unshift(element);
          });

          this.activityCenterService.createActivity(resourceDetailsActivity, this.hardCodedValues.addons, projectId);

          let data = {
            projectInfo: {
              clientName: profileValues.clientName,
              projectDescription: profileValues.projectDescription,
              projectName: profileValues.projectName,
              addOnType: profileValues.addOnType,
              projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
              reason: profileValues.reason ? profileValues.reason : '',
              currentStatus: profileValues.currentStatus,
              projectStartDate: this.dateConvertor.addGMTOffset(new Date(profileValues.projectStartDate)).toISOString(),
              actualCompletionDate: profileValues.actualCompletionDate == null || profileValues.actualCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.actualCompletionDate)).toISOString(),
              extendedCompletionDate: profileValues.extendedCompletionDate == null || profileValues.extendedCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.extendedCompletionDate)).toISOString(),
              projectPlatform: profileValues.projectPlatform,
              srs: this.srs,
              plan: this.plan,
            },
            activities: this.projectActivities,
            resourceDetails: resourceDetails
          };

          if (this.projecttypeInfo != data.projectInfo.projectType) {
            this.toastr.info('Please change the resource type of assigned resources in this addon');
          }

          this.projectInterface.updateProject(this.objectId, data).then(result => {
            this.currentStatus = result.get('projectInfo').currentStatus;

            if (profileValues.currentStatus == 'Completed') {
              this.statusdisable = true;
            }

            this.getProject();
            this.getProjectInformation();
            this.getActivities();

            // this._scrumboardService.updateScrumboard(this.objectId, data);
          });

          if (this.isResourceChanged) {
            this.isResourceChanged = false;
          }
          this.toastr.success(this.toastMessage.Update);
        } else if (this.show == true) {
          let profileValues = this.projectInformationForm.value;
          let resourceDetails = {
            details: this.dataSources.data,
            resourceDetailDate: this.dateConvertor
              .addGMTOffset(new Date(this.resourceDetailDate))
              .toISOString()
          };


          let activities = await this.getActivity(this.currentProjectDetails.projectInfo, profileValues);
          activities.forEach(element => {
            this.projectActivities.unshift(element);
          });

          const projectId = this.objectId;

          let activitiesCenter = await this.activityCenterService.getActivity(this.currentDetails, profileValues, this.hardCodedValues.addons);
          this.activityCenterService.createActivity(activitiesCenter, this.hardCodedValues.addons, projectId);

          // this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, projectId);

          let resourceDetailsActivity = await this.getActivityResource(this.currentResourcetDetails, resourceDetails.details);
          resourceDetailsActivity.forEach(element => {
            this.projectActivities.unshift(element);
          });

          this.activityCenterService.createActivity(resourceDetailsActivity, this.hardCodedValues.addons, projectId);

          let data = {
            projectInfo: {
              clientName: profileValues.clientName,
              projectDescription: profileValues.projectDescription,
              projectName: profileValues.projectName,
              addOnType: profileValues.addOnType,
              projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
              reason: profileValues.reason ? profileValues.reason : '',
              currentStatus: profileValues.currentStatus,
              projectStartDate: this.dateConvertor.addGMTOffset(new Date(profileValues.projectStartDate)).toISOString(),
              actualCompletionDate: profileValues.actualCompletionDate == null || profileValues.actualCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.actualCompletionDate)).toISOString(),
              extendedCompletionDate: profileValues.extendedCompletionDate == null || profileValues.extendedCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.extendedCompletionDate)).toISOString(),
              projectPlatform: profileValues.projectPlatform,
              srs: this.srs,
              plan: this.plan,
            },

            activities: this.projectActivities,
            resourceDetails: resourceDetails
          };

          if (this.projecttypeInfo != data.projectInfo.projectType) {
            this.toastr.info('Please change the resource type of assigned resources in this addon');
          }

          this.projectInterface.updateProject(this.objectId, data).then(result => {

            if (profileValues.currentStatus == 'Completed') {
              this.statusdisable = true;
            }

            this.currentStatus = result.get('projectInfo').currentStatus;
            this.getProjectInformation();
            this.getActivities();

            // this._scrumboardService.updateScrumboard(this.objectId, data);
          });

          if (this.isResourceChanged) {
            this.isResourceChanged = false;
          }
          this.toastr.success(this.toastMessage.Update);
        }
      }

    }
    else if (errorArray.length > 0) {
      let validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }
  }

  getResourceActivity(oldValue, newValue): any[] {
    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createResourceActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);

          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });

            } else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  getActivity(oldValue, newValue): any[] {
    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);

          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });

            } else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  createActivity(property, oldValue, newValue): any {
    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;
    const type = this.typeCheck((property === 'projectStartDate' || property === 'actualCompletionDate' || property === 'extendedCompletionDate') ? newValue._d : newValue);
    switch (type) {
      case 'string':
        if (oldValue !== newValue) {
          switch (property) {

            case 'projectName':
              const oldProjectName = oldValue !== '' ? oldValue : '';
              const newProjectName = newValue;
              message = oldProjectName === '' ? 'Added a Project Name - ' + newProjectName : 'Changed project name from ' + oldProjectName + ' to ' + newProjectName;
              break;

            case 'projectDescription':
              const oldProjectDescription = oldValue !== '' ? oldValue : '';
              const newProjectDescription = newValue;
              // tslint:disable-next-line: max-line-length
              message = oldProjectDescription === '' ? 'Added a Project Description - ' + newProjectDescription : 'Changed project description from ' + oldProjectDescription + ' to ' + newProjectDescription;
              break;

            case 'projectType':
              const oldProjecType = oldValue !== '' ? this.projectLists.filter(x => x.value === oldValue) : '';
              const newProjectType = this.projectLists.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              if (newProjectType.length > 0) {
                message = oldProjecType === '' ? 'Added a Project Type - ' + newProjectType[0].value : 'Changed project type from ' + oldProjecType[0].value + ' to ' + newProjectType[0].value;
              }
              break;

            case 'reason':
              const oldReason = oldValue !== '' ? oldValue : '';
              const newReason = newValue;
              // tslint:disable-next-line: max-line-length
              message = oldReason === '' ? 'Added a Project Reason - ' + newReason : 'Changed project reason from ' + oldReason + ' to ' + newReason;
              break;

            case 'currentStatus':
              const oldStatus = oldValue !== '' ? this.projectStatusList.filter(x => x.value === oldValue) : '';
              const newStatus = this.projectStatusList.filter(x => x.value === newValue);
              message = oldStatus === '' ? 'Added a Current Staus - ' + newStatus[0].value : 'Changed current status from ' + oldStatus[0].value + ' to ' + newStatus[0].value;
              this.projectStatusList = [];
              break;

            case 'addOnType':
              const newAddOnType = this.addons.filter(x => x.value === newValue);
              const oldAddOnType = oldValue !== '' ? this.addons.filter(x => x.value === oldValue) : '';
              // tslint:disable-next-line: max-line-length
              message = oldAddOnType === '' ? 'Added a AddOn Type - ' + newAddOnType[0].value : 'Changed AddOn Type from ' + oldAddOnType[0].value + ' to ' + newAddOnType[0].value;
              break;
          }
          allow = true;
        }
        break;

      case 'Date':
        const datePipe = new DatePipe('en-US');
        const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
        const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
        if (oldDate !== newDate) {
          message = oldValue === '' ? 'Added a ' + property : 'Updated the ' + property + ' from ' + oldDate + ' to ' + newDate;
          allow = true;
        }
        break;

      case 'Array':
        switch (property) {
          case 'projectPlatform':
            let arrayValue = [];
            arrayValue = this.arrayDifference(oldValue, newValue);
            arrayValue.forEach(element => {
              const val1 = oldValue.includes(element);
              const val2 = newValue.includes(element);
              messages.push(val1 === false && val2 === true ? 'Added a ' + property + ' - ' + element : 'Removed a ' + property + ' - ' + element);
            });
            allow = true;
            break;

        }
        break;
    }

    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.setActivityModel(message);
      return { activity: activity, allow, type };
    }
  }

  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.value == current.value && other.display == current.display
      }).length == 0;
    };
  }

  typeCheck(Source): string {
    if (Source != null) {
      if (Source.constructor === Array) {
        return 'Array';
      } else if (Source.constructor === Object) {
        return 'object';
      } else if (Source.constructor === String) {
        return 'string';
      } else if (Source.constructor === Date) {
        return 'Date';
      } else if (Source.constructor === Number) {
        return 'Number';
      }
    }
  }

  arrayDifference(array1, array2) {
    let array = [];
    array1 = array1.toString().split(',');
    array2 = array2.toString().split(',');
    // for array1
    for (let i in array1) {
      if (array2.indexOf(array1[i]) === -1) {
        array.push(array1[i]);
      }
    }
    // for array2
    for (let i in array2) {
      if (array1.indexOf(array2[i]) === -1) {
        array.push(array2[i]);
      }
    }
    return array.sort((x, y) => x - y);
  }

  setActivityModel(message): any {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    const createrName = createrProfile.get('username');
    const activity = {
      message: message,
      createdBy: createrName,
      createdId: createrProfile.id,
      createdDate: new Date().toUTCString(),
      createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
    };
    return activity;
  }

  resourceDetailcomparer(otherArray) {
    let projectType = this.projectInformationForm.value.projectType ? this.projectInformationForm.value.projectType : this.projectInformationForm.value.addOnType;
    return function (current) {
      return otherArray.filter(function (other) {
        if (projectType === 'Dedicated') {
          return other.role === current.role && other.count === current.count;
        }
        else if (projectType === 'Support') {
          return other.role === current.role && other.count === current.count;
        }
        else if (projectType === 'Fixed') {
          return other.role === current.role && other.count === current.count && other.hours === current.hours;
        }
      }).length === 0;
    };
  }

  checkCountDiff(oldValue, newValue, projectType) {
    let activities = []
    if (projectType === 'Dedicated') {
      newValue.forEach(newDetails => {

        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
        });
      });
    }
    else if (projectType === 'Support') {
      newValue.forEach(newDetails => {

        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
        });
      });
    } else if (projectType === 'Fixed') {
      newValue.forEach(newDetails => {
        oldValue.filter(oldDetails => {
          if (newDetails.role === oldDetails.role && newDetails.count !== oldDetails.count) {
            let message = 'Changed the ' + oldDetails.role + ' count ' + oldDetails.count + ' to ' + newDetails.count;
            activities.push(this.setActivityModel(message));
          }
          if (newDetails.role === oldDetails.role && newDetails.hours !== oldDetails.hours) {
            let message = 'Changed the ' + oldDetails.role + ' Hours ' + oldDetails.hours + ' to ' + newDetails.hours;
            activities.push(this.setActivityModel(message));
          }
        });
      });

    }
    return activities;
  }

  getActivityResource(oldValue, newValue) {
    let activities = [];
    let projectType = this.projectInformationForm.value.projectType ? this.projectInformationForm.value.projectType : this.projectInformationForm.value.addOnType;
    let countAndHourActivity = this.checkCountDiff(oldValue, newValue, projectType);

    if (countAndHourActivity.length > 0) {
      countAndHourActivity.forEach(element => {
        activities.unshift(element);
      });
    }
    if (oldValue.length !== newValue.length) {
      var onlyInA = oldValue.filter(this.resourceDetailcomparer(newValue));
      var onlyInB = newValue.filter(this.resourceDetailcomparer(oldValue));

      if (onlyInA.length > onlyInB.length) {
        onlyInA.forEach(element => {
          let activityNew = [];
          let message;
          if (element.hours > 0) {
            message = ' Removed a role ' + element.role + ' Count - ' + element.count + ' ,Hours - ' + element.hours;
          } else {
            message = ' Removed a role ' + element.role + ' Count - ' + element.count;
          } activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            activities.unshift(element);
          });
        });
      }
      if (onlyInA.length < onlyInB.length) {
        onlyInB.forEach(element => {
          let activityNew = [];
          let message;
          if (element.hours > 0) {
            message = ' Added a role ' + element.role + ' Count - ' + element.count + ' ,Hours - ' + element.hours;
          }
          else {
            message = ' Added a role ' + element.role + ' Count - ' + element.count;
          }
          activityNew.push(this.setActivityModel(message));
          activityNew.forEach(element => {
            activities.unshift(element);
          });
        });
      }
    }
    return activities;
  }

  createProjectInformation() {

    let allowSave = true;
    let errorArray = [];
    let controls = this.projectInformationForm.controls;

    if (this.projectInformationForm.value.addOnType == 'Support' || this.projectInformationForm.value.addOnType == 'Task') {
      for (const value in controls) {
        if (controls[value].invalid) {
          if (value != 'projectType') {
            allowSave = false;
            errorArray.push(value);
          }
        }
      }
    } else {
      for (const value in controls) {
        if (controls[value].invalid) {
          allowSave = false;
          errorArray.push(value);
        }
      }
    }

    if (this.dataSources.data.length <= 0) {
      allowSave = false;
      errorArray.push('Resources');
    }
    const roleCheck = this.dataSources.data.filter(a => a.role == '');
    const resourceCheck = this.dataSources.data.filter(a => a.count == 0);
    const hourCheck = this.dataSources.data.filter(a => a.hours == 0 || a.hours == null);
    if (roleCheck.length > 0) {
      allowSave = false;
      errorArray.push('Role');
    }
    if (resourceCheck.length > 0) {
      allowSave = false;
      errorArray.push('No Of Resources');
    }
    if (hourCheck.length > 0 && (this.projectInformationForm.value.projectType == 'Fixed' || this.projectInformationForm.value.addOnType == 'Task')) {
      allowSave = false;
      errorArray.push('Hours');
    }

    if (allowSave) {
      if (this.show == false) {

        let profileValues = this.projectInformationForm.value;
        let resourceDetails = {
          id: this.getRandomNumber(9),
          details: this.dataSources.data,
          resourceDetailDate: new Date()
        };
        let data = {
          projectInfo: {
            clientName: profileValues.clientName,
            projectDescription: profileValues.projectDescription,
            projectName: profileValues.projectName,
            addOnType: profileValues.addOnType,

            projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
            reason: profileValues.reason ? profileValues.reason : '',

            currentStatus: profileValues.currentStatus,
            projectPlatform: profileValues.projectPlatform,
            projectStartDate: this.dateConvertor.addGMTOffset(profileValues.projectStartDate).toISOString(),
            actualCompletionDate: profileValues.actualCompletionDate == null || profileValues.actualCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.actualCompletionDate)).toISOString(),
            extendedCompletionDate: profileValues.extendedCompletionDate == null || profileValues.extendedCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.extendedCompletionDate)).toISOString(),
            srs: this.srs,
            plan: this.plan,
          },
          resourceDetails: resourceDetails
        };

        this.projectInformation = this.projectInformationForm.value;
        let activities = [];
        let message = 'Created a Addon ' + this.projectInformation.projectName;
        let activity = this.activityCenterService.setActivityModel(message);
        activities.push(activity);

        let ProjectClass = this.parseService.instance.Object.extend('Project');
        var projectDetails = new ProjectClass();
        projectDetails.set('projectInfo', data.projectInfo);
        var client = new this.parseService.instance.Object('Client');
        client.id = profileValues.clientName;
        projectDetails.set('client', client);
        projectDetails.set('comments', []);
        projectDetails.set('projectType', 'Sub-Project');
        projectDetails.set('isActive', true);
        projectDetails.set('resourceDetails', data.resourceDetails);
        projectDetails.set('activities', activities);
        projectDetails.save().then(res => {
          this.isEditValue.emit((this.isEdit = true));
          this._scrumboardService.createScrumBoard(res);
          this.getActivities();
          this.addProjectRelation(res);

          this.objectId = res.id;

          this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);

          this.isEditValue.emit((this.isEdit = true));

          if (this.isResourceChanged) {
            this.isResourceChanged = false;
          }
          this.toastr.success('Add-ons created Successfully');
          this.router.navigate(['add-ons', { id: this.ProjectId, events: res.id }]);
          // this.router.navigate(['project-detail', {id: res.id}]);
        },
          err => { }

        );
      } else if (this.show == true) {
        let profileValues = this.projectInformationForm.value;
        // const startdate = profileValues.projectStartDate;
        // const enddate = profileValues.actualCompletionDate;
        let resourceDetails = {
          id: this.getRandomNumber(9),
          details: this.dataSources.data,
          resourceDetailDate: new Date()
        };

        let data = {
          projectInfo: {
            clientName: profileValues.clientName,
            projectDescription: profileValues.projectDescription,
            projectName: profileValues.projectName,
            projectType: profileValues.addOnType == 'Support' || profileValues.addOnType == 'Task' ? '' : profileValues.projectType,
            reason: profileValues.reason ? profileValues.reason : '',
            addOnType: profileValues.addOnType,
            currentStatus: profileValues.currentStatus,
            projectStartDate: this.dateConvertor.addGMTOffset(new Date(profileValues.projectStartDate)).toISOString(),
            projectPlatform: profileValues.projectPlatform,
            actualCompletionDate: profileValues.actualCompletionDate == null || profileValues.actualCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.actualCompletionDate)).toISOString(),
            extendedCompletionDate: profileValues.extendedCompletionDate == null || profileValues.extendedCompletionDate == '' ? '' : this.dateConvertor.addGMTOffset(new Date(profileValues.extendedCompletionDate)).toISOString(),
            srs: this.srs,
            plan: this.plan,
          },

        };
        this.projectInformation = this.projectInformationForm.value;

        let activities = [];
        let message = 'Created a Project ' + this.projectInformation.projectName;
        let activity = this.setActivityModel(message);
        activities.push(activity);

        let ProjectClass = this.parseService.instance.Object.extend('Project');
        var projectDetails = new ProjectClass();
        projectDetails.set('projectInfo', data.projectInfo);
        // projectDetails.set('otherInfo', data.otherInfo);
        var client = new this.parseService.instance.Object('Client');
        client.id = profileValues.clientName;
        projectDetails.set('client', client);
        projectDetails.set('comments', []);
        projectDetails.set('projectType', 'Sub-Project');
        projectDetails.set('isActive', true);
        projectDetails.set('resourceDetails', resourceDetails);
        projectDetails.set('activities', activities);
        projectDetails.save().then(res => {
          this.isEditValue.emit((this.isEdit = true));
          this._scrumboardService.createScrumBoard(res);
          this.getActivities();
          this.addProjectRelation(res);
          this.objectId = res.id;
          this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);

          this.isEditValue.emit((this.isEdit = true));

          if (this.isResourceChanged) {
            this.isResourceChanged = false;
          }
          // this.toastr.success(this.toastMessage.Save);
          this.toastr.success('Project Created Successfully');
          this.router.navigate(['add-ons', { id: this.ProjectId, events: res.id }]);
          // this.ngOnInit();
        },
          err => { }
        );
      }
    } else if (errorArray.length > 0) {
      let validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }
  }


  selectChange(event) {
    this.rowDatas.forEach(element => {
      element.isSelected = false;
    });
    this.selectedRows.forEach(element => {
      element.isSelected = true;
    });
  }

  dateChange(event) {
    return this.dateConvertor.addGMTOffset(event.value);
  }

  saveAssignedResource() {
    var selectedRow = this.selectedRows;
    this.selectedResource = [];
    this.roleDropChange();
    selectedRow.forEach(element => {
      var profile = new this.parseService.instance.Object('Profile');
      var project = new this.parseService.instance.Object('Project');
      if (this.empRole == 'Admin') {
        project.id = this.objectId;
      }
      if (this.empRole == 'Leader') {
        project.id = this.projectId == undefined ? this.objectId : this.projectId;
      }
      profile.id = element.objectId;
      this.selectedResource.push({
        name: element.userName,
        startDate: element.startDate,
        endDate: new Date(this.endDate),
        resourceType: element.resourceType,
        userId: profile,
        projectId: project,
        isActive: true,
        status: 'Assigned',
        role: element.role
      });
    });
    this.resourceForm.reset();
    this.addRow();
  }

  editResource(event) {
    this.queryInterface.executeQuery(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 1000 },
      { condition: 'notContainedIn', field: 'objectId', value: this.userIds }]).then(results => {
        this.rowDatas = this.loadResources(results);
        this.userId = event;
        this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
          { condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
            var results = result[0];
            var project = new this.parseService.instance.Object('Project');
            if (this.empRole == 'Admin') {
              project.id = this.objectId;
            }
            if (this.empRole == 'Leader') {
              project.id = this.projectId == undefined ? this.objectId : this.projectId;
            }
            this.reAssignResourcePopupForm.patchValue({
              name: results.get('username'),
              startDate: results.get('startDate') ? results.get('startDate') : new Date(),
              endDate: results.get('endDate') ? results.get('endDate') : new Date(),
              resourceType: results.get('resourcesType'),
              projectId: project,
              isActive: true,
              status: 'Assigned',
              role: results.get('role')
            });
            this.oldReassignValue = JSON.parse(JSON.stringify(this.reAssignResourcePopupForm.value));
            this.dialog.open(this.reAssignResourcePopup);
          });
      }).catch(err => {
        this.sessionHandler.handleParseError(err);
      });
  }

  async reassignResourceSave() {
    this.selectedResource = [];
    if (this.reAssignResourcePopupForm.value.userId !== '' && this.reAssignResourcePopupForm.value.userId !== null) {
      let formValue = this.reAssignResourcePopupForm.value;
      this.newValues = this.reAssignResourcePopupForm.value;
      formValue.name = formValue.userId.userName;
      formValue.userId = formValue.userId.objectId;
      formValue.startDate = this.dateConvertor.addGMTOffset(formValue.startDate);
      formValue.endDate = this.dateConvertor.addGMTOffset(formValue.endDate);
      this.selectedResource.push(formValue);
      this.reassignSave = true;
      await this.popupAdd(this.reassignSave);
      this.reAssignResourcePopupForm.patchValue({
        userId: '',
      });
    }
    else {
      this.toastr.warning('Please Enter all the fields');
    }
  }

  getRandomNumber(val) {
    let timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  addProjectRelation(addOnResult) {
    var queryRel = new this.parseService.instance.Query('Project');
    queryRel.equalTo('objectId', this.ProjectId);
    queryRel.first().then(function (add) {
      var relation = add.relation('addOn');
      relation.add(addOnResult);
      add.save().then((result) => {
      }, function (error) {
      });
      return add;
    });
  }

  async getResourceType() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let results = await query.find();
    let result = results[0];
    let resourceType = result.get('resourceRole');
    this.resourceDropdown = resourceType;
    if (this.dataSources.data.length > 0) {
      this.dataSources.data.forEach(element => {
        this.resourceDropdown.splice(this.resourceDropdown.findIndex(a => a == element.role), 1);
      });
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  deleteResourceType(element) {
    let res = this.assignedResources.filter(x => x.role == element.role);
    if (res.length > 0) {
      let count = res.length;
      this.toastr.warning('Please release ( ' + count + ' ' + element.role + ' Resource ) before deleting role');
    } else {
      let data = [];
      data = this.dataSources.data;
      let index = data.findIndex(a => a.id == element.id);
      data.splice(index, 1);
      this.dataSources.data = data;
      if (element.role != '') {
        this.resourceDropdown.push(element.role);
      }
      this.isResourceChanged = true;
      this.changeCount(0, '');
      this.changeHourCount(0);
    }
  }

  addResourceType() {
    let data = this.dataSources.data;
    let id = this.getRandomNumber(9);
    data.push({
      id: id,
      role: '',
      count: 0,
      hours: 0
    });
    this.dataSources.data = data;
  }

  roleChange(event) {
    this.isResourceChanged = true;
    this.resourceDropdown.splice(this.resourceDropdown.findIndex(s => s == event), 1);
  }

  editbacklocation() {
    this.typeOfProject = 'Project';
    this.router.navigate(['project-detail', { id: this.parentProjectId, index: 4, projectType: this.typeOfProject }]);
  }
  newbacklocation() {
    this.typeOfProject = 'Project';
    this.router.navigate(['project-detail', { id: this.ProjectId, index: 4, projectType: this.typeOfProject }]);
  }

  async onClick(event) {
    this.assignee.reset();
    this.release.reset();
    this.name = '';
    this.mail = '';
    this.resource = [];
    this.desig = [];
    this.roleType = [];
  }

  async getReleasedResources() {
    let id = '';
    if (this.empRole != 'Employee') {
      id = this.objectId;
    } else if (this.empRole == 'Employee') {
      id = this.objectId;
    }
    this.totalReleasedResources = await this.getCounts('Released');
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: id } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Released' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'user.profile' }
    ]).then(results => {
      this.releasedResources = this.loadValue(results, 0);
    })
  }

  loadValue(results, skip) {
    let i = skip;
    let result = [];
    results.forEach((element, index) => {
      i = i + 1;
      let userObject = element.get('user');
      let profile = userObject.get('profile');
      this.userIdArr.push(element);
      let roleObj = profile.get('role');
      let emailObj = profile.get('officialInfo');
      let jsonText = JSON.stringify(element);
      let userRole = JSON.parse(jsonText);
      result.push({
        objectId: userRole.objectId,
        position: i,
        username: profile.get('firstName') + ' ' + profile.get('lastName'),
        startDate: this.dateConvertor.momentChange(userRole.startDate.iso),
        endDate: this.dateConvertor.momentChange(userRole.endDate.iso),
        resourceType: userRole.resourcesType,
        status: userRole.status,
        email: emailObj.officialEmail,
        designation: roleObj.get('name'),
        action: ''
      });
    });
    return result;
  }

  getCounts(type) {
    let id = '';
    if (this.empRole != 'Employee') {
      id = this.objectId;
    } else if (this.empRole == 'Employee') {
      id = this.projectId;
    }
    return this.queryInterface.getQueryCount(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: id } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: type },
      { condition: 'include', value: 'profile' },
      { condition: 'include', value: 'profile.role' }
    ]);
  }

  getProject() {
    this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
      this.projetcDetails = result[0];
      this.activity = this.projetcDetails.get('activities') == undefined ? [] : this.projetcDetails.get('activities');
      this.endDate = this.projetcDetails.get('projectInfo').actualCompletionDate;
      let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
      this.totalCount = 0;
      resourcesDetails.forEach(element => {
        this.totalCount += element.count;
      });
      this.roleDrop();
    });
  }

  async getLeadersProjectId() {
    if (this.empRole == 'Employee') {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [{ condition: 'include', value: 'client' },
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'user' },
        { condition: 'include', value: 'project.client' },
        { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]).then(results => {
          var result = results[0];
          var Finalres = result.get('project');
          this.projectId = Finalres.id;
          this.projectName = Finalres.get('projectInfo').projectName;
        });
    } else {
      this.projectId = this.objectId;
      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(results => {
        var result = results[0];
        this.projectName = result.get('projectInfo').projectName;
      });
    }
  }

  async getLocation() {
    await this.getReportingToService.getLocation().then(res => {
      this.locationOptions = res;
    });
  }

  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  getRollOption() {
    let result = [];
    let resultDD = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        result.push({ name: roleList.name, id: roleList.objectId });
        resultDD.push(roleList.name);
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
      this.rollOptions1 = this.bindRoleDropDown(resultDD);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }
  bindRoleDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  async getEmployeesProject(userids) {
    this.totalResources = await this.getResourcesCount();
    this.queryInterface.executeQuery(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 10 },
      { condition: 'notContainedIn', field: 'objectId', value: userids },
    ]).then(results => {
      this.roleDropChange();
      this.rowDatas = this.loadResources(results);
    }).catch(err => {
      this.sessionHandler.handleParseError(err);
    });
  }

  async getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
    ]);
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  resourcesDelete(resource) {
    this.selectedResource.splice(this.selectedResource.findIndex(x => x == resource), 1);
    if (this.selectedResource.length == 0) {
      this.dialog.closeAll();
    }
  }

  async getAssignedResources() {
    let id = '';
    if (this.empRole != 'Employee') {
      id = this.objectId;
    } else if (this.empRole == 'Employee') {
      id = this.objectId;
    }
    this.totalAssignedResources = await this.getCountAssigned('Assigned');
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Assigned' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'project' },
      { condition: 'include', value: 'user.profile' }]).then(results => {
        results.forEach((element, index) => {
          let userObject = element.get('user');
          let profile = userObject.get('profile');
          this.userCompareId = profile.id;
          this.userIds.push(this.userCompareId);
        });
        this.rowData = this.loadValues(results, 0);
        this.assignedResources = this.loadValues(results, 0);
        // tslint:disable-next-line: max-line-length
        let projectType = this.projectInformationForm.value.projectType;
        this.nonBillableCount = this.assignedResources.filter(a => a.resourceType == (projectType == 'Dedicated' ? 'Dedicated-Billable' : 'Fixed-Billable'));
        this.supportBillableCount = this.assignedResources.filter(a => a.resourceType == 'Support-Billable');
      });
  }

  getCountAssigned(type) {
    let id = '';
    if (this.empRole == 'Admin') {
      id = this.objectId;
    } else if (this.empRole != 'Admin') {
      id = this.projectId;
    }
    return this.queryInterface.getQueryCount(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: id } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: type },
      { condition: 'include', value: 'profile' },
      { condition: 'include', value: 'profile.role' }
    ]);
  }

  loadValues(results, skip) {
    let i = skip;
    let result = [];
    results.forEach((element, index) => {
      i = i + 1;
      let userObject = element.get('user');
      let profile = userObject.get('profile');
      this.userIdArr.push(element);
      let roleObj = profile.get('role');
      let emailObj = profile.get('officialInfo');
      let jsonText = JSON.stringify(element);
      let userRole = JSON.parse(jsonText);
      result.push({
        objectId: userRole.objectId,
        position: i,
        username: profile.get('firstName') + ' ' + profile.get('lastName'),
        startDate: this.dateConvertor.momentChange(userRole.startDate.iso),
        endDate: this.dateConvertor.momentChange(userRole.endDate.iso),
        resourceType: userRole.resourcesType,
        status: userRole.status,
        email: emailObj.officialEmail,
        designation: roleObj.get('name'),
        role: element.get('role') == undefined ? '' : element.get('role'),
        action: ''
      });
    });
    return result;
  }

  onChangeEvent(event, resourceName) {
    this.selectedResource.forEach(element => {
      if (element.id == resourceName) {
        element.startDate = this.dateConvertor.addGMTOffset(event.value);

      }
    });
  }

  async onLazyLoadAddResources(event: LazyLoadEvent) {
    this.selectedRows = [];
    this.loadEventData = event;
    let condition = [];
    condition = [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' }
    ];

    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      if (this.userIds.length > 0) {
        condition.push({ condition: 'notContainedIn', field: 'objectId', value: this.userIds });
      }
      this.totalResources = await this.getTotalRecordsCount(condition);
      this.lazyLoadAddResources(condition, skip, event.rows);

    } else if (event.sortField) {
      const skip: number = event.first;

      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';

      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
          condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
        } else {

          if (key != 'officialInfo.officialEmail') {
            filter[key].value = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filter[key].value });
        }
      }
      let sortCondition = {};
      if (sortOrder == 'ascending') {
        sortCondition = { condition: sortOrder, value: field };
      } else {
        sortCondition = { condition: sortOrder, field: field };
      }
      this.totalResources = await this.getTotalRecordsCount(condition);
      if (this.totalResources < event.first) {
        event.first = 0;
      }
      condition.push(sortCondition);
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else {
      if (this.userIds.length > 0) {
        condition.push({ condition: 'notContainedIn', field: 'objectId', value: this.userIds });
      }
      for (let key in filter) {
        let query = filter[key].value;

        if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
          condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
        } else {
          if (key != 'officialInfo.officialEmail') {
            filter[key].value = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filter[key].value });
        }
      }

      this.totalResources = await this.getTotalRecordsCount(condition);
      if (this.totalResources < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, event.first, event.rows);
    }

  }
  getTotalRecordsCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', condition);
  }

  lazyLoadAddResources(condition, skip, limit) {
    condition.push({ condition: 'skip', value: skip },
      { condition: 'limit', value: limit });
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      this.rowDatas = this.loadResources(results);
    });
  }

  roleDrop() {
    let roleOptions = [];
    let role = this.projetcDetails.get('resourceDetails').details;
    role.forEach(element => {
      roleOptions.push(element.role);
    });
    this.roles = roleOptions;
    this.roleOptionsDD = this.bindRoleDropDown(roleOptions);

  }

  roleDropChange() {
    let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
    // this.roles = this.roleOptions;
    let role = JSON.parse(JSON.stringify(this.roles));
    this.roles.forEach(element => {
      let resourceByRole = this.rowData.filter(x => x.role == element);
      let roleCount = resourcesDetails.filter(x => x.role == element)[0].count;
      if (resourceByRole.length >= roleCount) {
        // var a = role.indexOf(element);
        role.splice(role.indexOf(element), 1);
      }
    });
    this.roleOptions = role;
  }

  loadResources(results) {
    let result = [];
    this.filterArray.forEach(item2 => {
      results = results.filter(item1 => {
        return JSON.stringify(item1) !== JSON.stringify(item2);
      });
    });
    results.forEach((element, index) => {
      let rolePoint = element.get('role');
      let locationPoint = element.get('location');
      let reportingPoint = element.get('reportingTo');
      let officialInfo = element.get('officialInfo');
      let departmentPoint = element.get('department');
      result.push({
        position: index + 1,
        userName: element.get('firstName') + ' ' + element.get('lastName'),
        officialEmail: officialInfo.officialEmail,
        designation: rolePoint.get('name'),
        department: departmentPoint.get('name'),
        location: locationPoint.get('name'),
        reportingTo: reportingPoint.get('username'),
        objectId: element.id,
        role: '',
        startDate: '',
        resourceType: '',
        isSelected: false,
        action: ''
      });
    });
    return result;
  }

  onResourceChange(events, resourceName) {
    this.selectedResource.forEach(element => {
      if (element.id == resourceName) {
        element.resourceType = events.value;
      }
    });
  }

  async addRow() {
    let roleValid = this.selectedResource.filter(a => a.role == '');
    let dateValid = this.selectedResource.filter(b => b.startDate == '');
    let resourceValid = this.selectedResource.filter(c => c.resourceType == '');
    if (roleValid.length > 0 || dateValid.length > 0 || resourceValid.length > 0) {
      this.toastr.warning('Please enter the  required fields');
      return false;
    }

    this.totalCount = 0;
    let rowAdd = true;
    let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
    resourcesDetails.forEach(element => {
      this.totalCount += element.count;
    });

    this.roles.forEach(element => {
      let roleByMember = this.rowData.filter(a => a.role == element);
      let resourcesDet = resourcesDetails.filter(s => s.role == element);
      let resourceCount = resourcesDet[0].count;
      let selectCount = this.selectedResource.filter(s => s.role == element);
      if ((roleByMember.length + selectCount.length) > resourceCount) {
        this.toastr.warning(element + ' Resource Limit is reached');
        rowAdd = false;
      }
    });

    if (rowAdd) {

      this.selectedResource.forEach(async element => {
        let userId;
        this.queryInterface.executeQuery(this.parseService, 'User', [
          { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: element.userId.id == undefined ? element.userId : element.userId.id } },
          { condition: 'include', value: 'profile' }]).then(results => {
            let project = element;
            let result = results[0];
            userId = result.id;
            let newValue = JSON.parse(JSON.stringify(project));
            let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
            var projectDetails = new ProjectClass();
            projectDetails.set('project', project.projectId);
            projectDetails.set('startDate', new Date(project.startDate));
            projectDetails.set('endDate', project.endDate == 'Invalid Date' ? new Date() : project.endDate);
            projectDetails.set('resourcesType', project.resourceType);
            projectDetails.set('username', project.name);
            projectDetails.set('isActive', project.isActive);
            projectDetails.set('status', project.status);
            projectDetails.set('role', project.role);
            projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userId });

            projectDetails.save().then(result => {
              let activityNew = [];
              this.currentUsername = project.name;

              if (this.reassignSave) {
                let message = 'Re-Assigned a resource ' + project.name + ' to ' + this.reAssignedResource;
                activityNew.push(this.setActivityModel(message));
                activityNew.forEach(element => {
                  this.activity.unshift(element);
                });
                // this.toastr.success('Resource Re-Assigned Successfully!!');
                this.getAssignedResources();
                this.getReleasedResources();
                this.getActivities();
                this.reassignSave = false;

                let activities = this.getResourceActivity(this.oldReassignValue, newValue);
                activities.forEach(element => {
                  this.activity.unshift(element);
                });
                this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);

              } else {
                let message = 'Added a resource ' + result.get('username') + ' as ' + project.role + ' ' + project.resourceType;
                activityNew.push(this.setActivityModel(message));
                activityNew.forEach(element => {
                  this.activity.unshift(element);
                });
                // this.toastr.success('Resource Assigned Successfully!');
                this.getAssignedResources();
                this.getReleasedResources();
                this.getActivities();
              }
              this.toastr.success('Resource Assigned Successfully!!');
              this.getAssignedResources();
              this.getReleasedResources();

              this.activityCenterService.createActivity(activityNew, this.hardCodedValues.addons, this.objectId);

              let id = '';
              id = this.empRole == 'Admin' ? this.objectId : this.projectId;

              this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
                var results = result[0];
                results.set('activities', this.activity);
                results.save().then(res => {
                  this.getActivities();
                });
              });
            });
          });
      });
      this.dialog.closeAll();
    }
  }

  createResourceActivity(property, oldValue, newValue): any {

    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;
    const type = this.typeCheck((property === 'startdate1' || property === 'enddate1') ? newValue._d : newValue);
    switch (type) {
      case 'string':
        if (oldValue !== newValue) {
          switch (property) {

            case 'popupRole':
              const oldRole = oldValue !== '' ? this.roleOptionsDD.filter(x => x.value === oldValue) : '';
              const newRole = this.roleOptionsDD.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              message = oldRole === '' ? 'Added a Role - ' + newRole[0].value + ' - Resource Name - ' + this.username : 'Changed role from ' + oldRole[0].value + ' to ' + newRole[0].value + ' - Resource Name - ' + this.username;
              allow = true;
              break;

            case 'popupResourcesType':
              const oldResourceType = oldValue !== '' ? this.resourcesTypeLists.filter(x => x.value === oldValue) : '';
              const newResourceType = this.resourcesTypeLists.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              message = oldResourceType === '' ? 'Added a Resource Type - ' + newResourceType[0].value + ' - Resource Name - ' + this.username : 'Changed resource type from ' + oldResourceType[0].value + ' to ' + newResourceType[0].value + ' - Resource Name - ' + this.username;
              allow = true;
              break;

            case 'startDate':
              let prop = this.hardCodedValues.getValues(property);

              const datePipe1 = new DatePipe('en-US');
              const oldDate1 = datePipe1.transform(oldValue, 'MMM dd yyyy');
              const newDate1 = datePipe1.transform(newValue, 'MMM dd yyyy');
              if (oldDate1 !== newDate1) {
                // tslint:disable-next-line: max-line-length
                message = oldValue === '' ? 'Added a ' + prop + ' - Resource Name - ' + this.currentUsername : 'Updated the ' + prop + ' from ' + oldDate1 + ' to ' + newDate1 + ' - Resource Name - ' + this.currentUsername;
                allow = true;
              }
              break;

            case 'endDate':
              let prop2 = this.hardCodedValues.getValues(property);

              const datePipe = new DatePipe('en-US');
              const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
              const newDate = datePipe.transform(newValue, 'MMM dd yyyy');
              if (oldDate !== newDate) {
                // tslint:disable-next-line: max-line-length
                message = oldValue === '' ? 'Added a ' + prop2 + ' - Resource Name - ' + this.currentUsername : 'Updated the ' + prop2 + ' from ' + oldDate + ' to ' + newDate + ' - Resource Name - ' + this.currentUsername;
                allow = true;
              }
              break;

            case 'popupStatus':
              message = 'Released a Resource' + ' ' + this.username
              allow = true;
          }
        }
        break;

      case 'Date':
        const datePipe = new DatePipe('en-US');
        const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
        const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
        if (oldDate !== newDate) {
          // tslint:disable-next-line: max-line-length
          message = oldValue === '' ? 'Added a ' + property + ' - Resource Name - ' + this.username : 'Updated the ' + property + ' from ' + oldDate + ' to ' + newDate + ' - Resource Name - ' + this.username;
          allow = true;
        }
        break;
    }

    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.setActivityModel(message);
      return { activity: activity, allow, type };
    }
  }

  filterApply(from, to) {
    let fromDate = new Date(from);
    let toDate = to !== '' ? new Date(new Date(to).setHours(23, 59, 59)) : new Date(new Date().setHours(23, 59, 59));
    if (from == '') {
      this.addOnsActivities = this.addOnsValue.activities;
    } else {
      let filteredActivities = this.addOnsValue.activities.filter(x => new Date(x.createdDate) >= new Date(fromDate) && new Date(x.createdDate) <= new Date(toDate));
      this.addOnsActivities = filteredActivities;
      this.activities = (this.addOnsActivities).slice(0, 50);
    }
  }

  getMinDate(date) {
    return new Date(date);
  }

  clearFilter() {
    this.addOnsActivities = this.addOnsValue.activities;
    this.activities = (this.addOnsActivities).slice(0, 50);
  }

  nextPage(event) {
    let activity = this.addOnsActivities;
    let start = event.pageIndex * event.pageSize;
    this.activities = activity.slice(start, start + event.pageSize);
  }

  public popupAdd(reassign) {

    let projectValues = this.popupForm.value;
    let projectInfo;
    let newValues = this.popupForm.value;

    let rowAdd = true;
    this.totalCount = 0;
    let formControls = this.popupForm.controls;
    let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
    resourcesDetails.forEach(element => {
      this.totalCount += element.count;
    });
    if (formControls.popupRole.dirty) {
      let roleByMember = this.rowData.filter(a => a.role == projectValues.popupRole);
      let resourcesDet = resourcesDetails.filter(s => s.role == projectValues.popupRole);
      let resourceCount = resourcesDet[0].count;
      if ((roleByMember.length + 1) > resourceCount) {
        this.toastr.warning(projectValues.popupRole + ' Resource Limit is reached');
        rowAdd = false;
      }
    }

    if (reassign) {
      projectInfo = {
        enddate1: this.dateConvertor.addGMTOffset(new Date()),
        // startdate1: this.dateConvertor.addGMTOffset(projectValues.startdate1),
        popupStatus: 'Released',
      };

      rowAdd = true;

    } else {
      projectInfo = {
        enddate1: this.dateConvertor.addGMTOffset(projectValues.enddate1),
        startdate1: this.dateConvertor.addGMTOffset(projectValues.startdate1),
        popupStatus: projectValues.popupStatus,
        role: projectValues.popupRole,
        resourceType: projectValues.popupResourcesType
      };
    }

    if (rowAdd) {
      this.projectInterface.updateProjectMember(this.userId, projectInfo);
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [{ condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
        var results = result[0];
        results.set('startDate', projectInfo.startdate1);
        results.set('endDate', projectInfo.enddate1);
        results.set('status', projectInfo.popupStatus);
        results.set('role', projectValues.popupRole);
        results.set('resourcesType', projectInfo.resourceType);
        results.save().then(async res => {
          if (rowAdd && !reassign) {
            this.toastr.success(this.toastMessage.Save);
          }
          if (reassign) {
            this.reAssignedResource = res.get('username');
            this.rowData.splice(this.rowData.findIndex(a => a.objectId == this.userId), 1);
            await this.addRow();
          }
          this.getAssignedResources();
          this.getReleasedResources();
          this.dialog.closeAll();
        });
      });
    }

    let activities = this.getResourceActivity(this.currentValues, newValues);
    activities.forEach(element => {
      this.activity.unshift(element);
    });

    this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);

    let id = '';
    id = this.empRole == 'Admin' ? this.objectId : this.projectId;
    this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
      var results = result[0];
      results.set('activities', this.activity);
      results.save().then(res => {
        this.getActivities();
      });
    });
  }

  nameClick(event) {
    this.dialog.open(this.projectEditPopup);
    this.userId = event;
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [{ condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
      var results = result[0];
      this.popupValue = this.projectInterface.getProjectMember(results);
      this.popupForm.patchValue({
        username: this.popupValue.username,
        startdate1: this.popupValue.startDate,
        enddate1: this.popupValue.endDate,
        popupStatus: this.popupValue.status,
        popupRole: this.popupValue.role,
        popupResourcesType: results.get('resourcesType')
      });
      this.currentValues = this.popupForm.value;
      this.username = this.popupForm.value.username;
      this.oldValueResource = JSON.parse(JSON.stringify(this.popupForm.value));
    });
    this.userId = event;
  }

  addresources() {
    if (this.empRole == 'Admin') {
      var selectedRow = this.selectedRows;
      this.roleDropChange();
      this.selectedResource = [];
      selectedRow.forEach(element => {
        var profile = new this.parseService.instance.Object('Profile');
        var project = new this.parseService.instance.Object('Project');
        project.id = this.objectId;
        profile.id = element.objectId;
        this.selectedResource.push({
          name: element.userName,
          startDate: '',
          endDate: new Date(this.projectInformationForm.value.actualCompletionDate),
          resourceType: '',
          userId: profile,
          projectId: project,
          isActive: true,
          status: 'Assigned',
          role: ''
        });
      });
      this.resourceForm.reset();
      this.dialog.open(this.projectaddonDialog, {
        width: '1200px'
      });
    }
    else if (this.empRole != 'Admin') {
      var selectedRow = this.selectedRows;
      this.selectedResource = [];
      selectedRow.forEach(element => {
        var profile = new this.parseService.instance.Object('Profile');
        var project = new this.parseService.instance.Object('Project');
        project.id = this.projectId;
        if (this.projectId === undefined) {
          project.id = this.objectId;
        }
        profile.id = element.objectId;
        this.selectedResource.push({
          name: element.userName,
          startDate: '',
          endDate: new Date(this.projectInformationForm.value.actualCompletionDate),
          resourceType: '',
          userId: profile,
          projectId: project,
          isActive: true,
          status: 'Assigned',
          role: ''
        });
      });
      this.resourceForm.reset();
      this.dialog.open(this.projectaddonDialog, {
        width: '1200px'
      });
    }
  }

  async resourcesPopup() {
    this.userIds = [];
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Assigned' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'project' },
      { condition: 'include', value: 'user.profile' }]).then(async results => {
        results.forEach((element, index) => {
          let userObject = element.get('user');
          let profile = userObject.get('profile');
          this.userCompareId = profile.id;
          this.userIds.push(this.userCompareId);
          this.getEmployeesProject(this.userIds);
        });
      });
    this.selectedRows = [];
    await this.getAssignedResources();
    this.getProject();
    this.roleDropChange();
    this.getDropDowns();
    this.dialog.open(this.projectDialog, {
      width: '1400px',
    });
  }

  getComments() {
    if (this.empRole != 'Employee') {
      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
        var results = result[0];
        this.commentData = results == undefined ? [] : results.get('comments');
      });
    }
    else if (this.empRole == 'Employee') {
      let result = [];
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [{ condition: 'include', value: 'client' },
      { condition: 'include', value: 'project' },
      { condition: 'include', value: 'project.client' },
      { condition: 'include', value: 'user' },
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]).then(results => {
        var result = results[0];
        let jsonText = JSON.stringify(result);
        let projectValue = JSON.parse(jsonText);
        this.commentData = projectValue.project.comments;
      });
    }
    if (this.commentData == []) {
      this.noData = true;
    }
  }

  addComment() {
    var commentValue = this.commentsForm.value.comments;
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    if (this.commentsForm.valid) {
      this.commentData.unshift({
        name: this.firstname.concat(' ' + this.lastname),
        comment: commentValue,
        date: this.newDate,
        createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      });
      let activities = [];
      let message = 'Added a comment';
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);
      if (this.empRole == 'Admin') {
        this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
          var results = result[0];
          results.set('comments', this.commentData);
          this.toastr.success('Comments Saved Successfully');
          results.save().then(res => {
            this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
          });
        });
      }
      else if (this.empRole != 'Admin') {
        this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.projectId }]).then(result => {
          var results = result[0];
          results.set('comments', this.commentData);
          this.toastr.success('Comments Saved Successfully');
          results.save().then(res => {
            this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
          });
        });
      }
    }
    else {
      this.toastr.error('Add comments');
    }
    this.commentsForm.patchValue({
      comments: ''
    });
  }

  tabChange(event) {
    if (event == 3) {
      this.index = 3;
    }
  }

}


export interface resourceTableModel {
  id: any;
  role: string;
  count: number;
  hours: number;

}
export interface addon {
  value: string;
  viewValue: string;
}


